const emojisRegex = /([\u203C-\u3299]|[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u200D\uFE0F\u2060])/g;
const unicodeLiteralRegex = /\\u\{?[0-9a-fA-F]{1,6}\}?/g;

export const cleanTextFomEmojis = (text: string) => {
	const cleaned = text.replace(emojisRegex, '');
	return cleaned.replace(unicodeLiteralRegex, '');
};

